export default __webpack_public_path__ + "static/media/121.7368df02.png";